import { z } from "zod";
import "../zod-runtime.js";
export const pointSchema = z.object({
    x: z.number().min(0).max(1000),
    y: z.number().min(0).max(1000),
    z: z.number().nullable().optional(),
});
/** `key` bleibt die stabile Identität (Record-Key, `unique(map_id,key)` in der DB); `label` ist der editierbare Anzeigetext. */
export const calloutSchema = pointSchema.extend({
    label: z.string().min(1),
});
